import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/subscriptions/user.ts
import { Exception } from "@wbk/logger";
var getSubscriptionById = (_0) => __async(null, [_0], function* ({ subscriptionId, lang }) {
  try {
    const url = `/subscriptions/user_subscriptions/${subscriptionId}?lang=${lang}`;
    const data = yield fetchClient({ url });
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getSubscriptionByIdException",
      context: { tags: { journey: "subscribe" }, extra: { subscriptionId } }
    });
  }
});
var getUserSubscriptions = (_0) => __async(null, [_0], function* ({ lang }) {
  try {
    const url = `/subscriptions/user_subscriptions?lang=${lang}&status=active`;
    const data = yield fetchClient({ url });
    return data.data.filter((sub) => sub.status === "active");
  } catch (error) {
    throw new Exception({
      error,
      name: "getUserSubscriptionsException",
      context: { tags: { journey: "subscribe" } }
    });
  }
});

export {
  getSubscriptionById,
  getUserSubscriptions
};
//# sourceMappingURL=chunk-A4ATQWYG.mjs.map